import axios from 'axios';
// config
import { HOST_API_KEY } from '../config-global';
import { isTabSessionStale, syncTabSession } from '../auth/sessionSync';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API_KEY });
// Never send a request as a user this tab no longer represents (the shared
// cookie was switched or cleared by another tab); resync the tab instead.
axiosInstance.interceptors.request.use((config) => {
  if (isTabSessionStale()) {
    syncTabSession();
    throw new axios.Cancel('Session changed in another tab');
  }
  return config;
});
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;
    if (data && typeof data === 'object') return Promise.reject(data);
    if (!error.response) return Promise.reject('Something went wrong');
    // A proxy/body-parser error (e.g. 413 HTML page) has no JSON message, so
    // screens showing `error.message` fell back to a generic text.
    const statusCode: number = error.response.status;
    return Promise.reject({
      statusCode,
      message:
        statusCode === 413
          ? 'The data sent is too large. Please use a smaller image or signature.'
          : 'Something went wrong',
    });
  },
);

export default axiosInstance;
